module.exports = __webpack_public_path__ + "static/img/40015 (5).115e662.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40015 (5).webp
// module id = cjSN
// module chunks = 14